import { theme } from '@atlas/shared/client/ui/core/theming';
import { css, unsafeCSS } from 'lit';

export const ratingElementStyles = css`
    :host lr-icon-star-filled {
        display: inline-block;
        cursor: default;
        transform: none;
        transition: none;
        color: ${unsafeCSS(theme.colors.base.black)};
        opacity: 0.3;
    }

    :host(:not(.disabled)) lr-icon-star-filled {
        cursor: pointer;
        transition: opacity 0.2s cubic-bezier(0.64, 0.57, 0.67, 1.53),
            transform 0.2s cubic-bezier(0.64, 0.57, 0.67, 1.53);
    }

    :host(:not(.disabled):hover) lr-icon-star-filled {
        transform: scale(1.1);
        opacity: 0.6;
    }

    :host(:not(.disabled):active) lr-icon-star-filled {
        opacity: 0.7;
    }

    :host([active]) lr-icon-star-filled {
        opacity: 1;
    }
`;
